import { StandaloneWrapper } from '@/src/common/wrappers/StandaloneWrapper'
import { RewardsComponentsAirlineAlliancesCard } from '../components/airlineAlliancesCard'
import { RewardsComponentsHotelNetworksCard } from '../components/hotelNetworksCard'
import { Button } from '@/src/common/components/Button'
import { useLogError } from '@/src/common/hooks/useLogError'
import { useOpenRedemptionPortal } from '@/src/common/hooks/useOpenRedemptionPortal'
import { useState } from 'react'
import { useIsTabBarPositionedTop } from '@/src/common/components/TopTabBar'
import { mesaColorNames } from '@/src/common/theme'

function PointsTransferInterstitial() {
  const { openRedemptionPortal } = useOpenRedemptionPortal()
  const logError = useLogError()
  const [loading, setLoading] = useState(false)
  const isTabBarPositionedTop = useIsTabBarPositionedTop()

  return (
    <StandaloneWrapper
      screen="/main/rewards/points-transfer"
      title="Points Transfer"
      profileProps={{
        style: isTabBarPositionedTop ? { visibility: 'hidden' } : { display: 'none' },
        menuIconProps: { color: mesaColorNames['Mesa - Brand/White #FFFFFF'] },
      }}
    >
      <RewardsComponentsAirlineAlliancesCard />
      <RewardsComponentsHotelNetworksCard />
      <Button
        title="Continue"
        loading={loading}
        style={{ marginBottom: 32 }}
        onPress={() => {
          void (async () => {
            try {
              setLoading(true)
              await openRedemptionPortal('Points Transfer', {
                variables: { redirectPath: '/products/frequent-traveler-programs' },
              })
            } catch (error) {
              logError('error opening points transfer portal', error)
            } finally {
              setLoading(false)
            }
          })()
        }}
      />
    </StandaloneWrapper>
  )
}

export const PointsTransferInterstitialScreen = {
  name: 'points-transfer',
  screen: PointsTransferInterstitial,
} as const
